import React from 'react';

type Props = {
  cricosCode: String;
  programRoute: String;
};

//this assumes we only have UWA as an australian partner
export default function CricosRequirements({ cricosCode, programRoute }: Props) {
  return (
    <div>
      <h5>CRICOS Provider Code</h5>
      <p>
        Provider: The University of Western Australia (UWA). UWA College in Partnership with INTO
        Perth. CRICOS 00126G
      </p>
      <h5>TEQSA Provider Identification</h5>
      <p>PRV12169, Australian University</p>
      {programRoute !== 'DirectEntry' && (
        <>
          <h5>CRICOS Course Code</h5>
          <p>{cricosCode}</p>
        </>
      )}
    </div>
  );
}
